import styled from "styled-components";

const TrainingStyle = styled.div`
    .training-filter-container{
        Width: 100%;
        display: flex;
        justify-content: space-between;
    }
    
    .export-reports-button{
        height: 2.5rem;
        min-width: 2.5rem;
        color: rgb(255, 255, 255);
        background-color: rgb(27, 104, 179);
        border: 1px solid rgb(27, 104, 179);

        &:hover{
            background-color: rgb(27, 104, 179) !important;
            border: 1px solid rgb(27, 104, 179) !important;
            color: rgb(255, 255, 255) !important;
        }
    }
`;

export default TrainingStyle;